import { render, staticRenderFns } from "./AlarmForm.vue?vue&type=template&id=382bac3f&scoped=true&"
import script from "./AlarmForm.vue?vue&type=script&lang=js&"
export * from "./AlarmForm.vue?vue&type=script&lang=js&"
import style0 from "./AlarmForm.vue?vue&type=style&index=0&id=382bac3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382bac3f",
  null
  
)

export default component.exports